import { getQueryStringParameter, clearInputField } from '../../../helpers';

import {
  clearAndHideMultipleFieldInputs,
  setupFatcaFiscalCountries,
  setUpFiscalTransparencyFields,
  toggleIsTaxableFields,
  toggleReasonIsNotTaxableFields,
} from '../fatca_nif_inputs';

$(() => {
  const $form = $('form#legal-profile-form');

  if ($form.length === 0 || getQueryStringParameter('id') !== 'fatca') {
    return;
  }

  setupFatcaFiscalCountries($form);
  setUpFiscalTransparencyFields($form);
  toggleIsTaxableFields($form);
  toggleReasonIsNotTaxableFields($form);

  const $americanNif = $('#american-nif-field', $form);
  const $americanCitizen = $('#is-us-citizen input[type=radio]', $form);
  const $nonAmericanCitizenFields = $('#non-us-citizen-fields');
  // Fatca fields
  const $fatcaForeignFinancialInstitutionTypeButtons = $('#fatca_foreign_financial_institution_type_buttons', $form);
  const $fatcaForeignNonFinancialInstitutionTypeButtons = $('#fatca_foreign_non_financial_institution_type_buttons', $form);
  const $otherFatcaForeignFinancialInstitutionType = $('#other_fatca_foreign_financial_institution_type', $form);
  const $model2FatcaForeignFinancialInstitutionType = $('#model_2_fatca_foreign_financial_institution_type', $form);
  const $waitingForGiinFatcaForeignFinancialInstitution_type = $('#waiting_for_giin_fatca_foreign_financial_institution_type');
  const $closedAndGovernedFatcaForeignFinancialInstitutionType = $('#closed_and_governed_fatca_foreign_financial_institution_type', $form);
  const $otherFatcaForeignNonFinancialInstitutionType = $('#other_fatca_foreign_non_financial_institution_type', $form);
  // CRS fields
  const $crsFinancialInstitutionFields = $('#crs_financial_institution_fields', $form);
  const $declaringCrsFinancialInstitutionButtons = $('#declaring_crs_financial_institution_buttons', $form);
  const $activeCrsNonFinancialInstitutionButtons = $('#active_crs_non_financial_institution_buttons', $form);

  $americanCitizen.on('change', (e) => {
    if (e.target.value === 'true') {
      $americanNif.removeClass('d-none');
      clearAndHideMultipleFieldInputs([
        $nonAmericanCitizenFields,
        $fatcaForeignFinancialInstitutionTypeButtons,
        $fatcaForeignNonFinancialInstitutionTypeButtons,
        $model2FatcaForeignFinancialInstitutionType,
        $waitingForGiinFatcaForeignFinancialInstitution_type,
        $closedAndGovernedFatcaForeignFinancialInstitutionType,
        $otherFatcaForeignFinancialInstitutionType,
        $otherFatcaForeignNonFinancialInstitutionType,
        $declaringCrsFinancialInstitutionButtons,
        $activeCrsNonFinancialInstitutionButtons,
      ])
    } else {
      $americanNif.addClass('d-none');
      $nonAmericanCitizenFields.removeClass('d-none');

      $('input', $americanNif).each((_, inputElement) => {
        clearInputField(inputElement);
      });
    }
  });

  // fatca_foreign_financial_institution_type logic

  $('#users_profile_legal_fatca_foreign_financial_institution_true').on('change', (_e) => {
    $fatcaForeignFinancialInstitutionTypeButtons.removeClass('d-none');
    clearAndHideMultipleFieldInputs([
      $fatcaForeignNonFinancialInstitutionTypeButtons,
      $otherFatcaForeignNonFinancialInstitutionType
    ]);
  });

  $('#users_profile_legal_fatca_foreign_financial_institution_false').on('change', (_e) => {
    $fatcaForeignNonFinancialInstitutionTypeButtons.removeClass('d-none');
    clearAndHideMultipleFieldInputs([
      $fatcaForeignFinancialInstitutionTypeButtons,
      $model2FatcaForeignFinancialInstitutionType,
      $waitingForGiinFatcaForeignFinancialInstitution_type,
      $closedAndGovernedFatcaForeignFinancialInstitutionType,
      $otherFatcaForeignFinancialInstitutionType,
    ]);
  });

  $($fatcaForeignFinancialInstitutionTypeButtons).on('change', (e) => {
    if (e.target.value === 'model_2') {
      $model2FatcaForeignFinancialInstitutionType.removeClass('d-none');
      $('input', $model2FatcaForeignFinancialInstitutionType).prop('disabled', false);
      $('input', $waitingForGiinFatcaForeignFinancialInstitution_type).prop('disabled', true);

      clearAndHideMultipleFieldInputs([
        $waitingForGiinFatcaForeignFinancialInstitution_type,
        $closedAndGovernedFatcaForeignFinancialInstitutionType,
        $otherFatcaForeignFinancialInstitutionType,
      ]);
    } else if (e.target.value == 'waiting_for_giin'){
      $waitingForGiinFatcaForeignFinancialInstitution_type.removeClass('d-none');
      $('input', $waitingForGiinFatcaForeignFinancialInstitution_type).prop('disabled', false);
      $('input', $model2FatcaForeignFinancialInstitutionType).prop('disabled', true);

      clearAndHideMultipleFieldInputs([
        $model2FatcaForeignFinancialInstitutionType,
        $closedAndGovernedFatcaForeignFinancialInstitutionType,
        $otherFatcaForeignFinancialInstitutionType,
      ]);
    } else if (e.target.value === 'closed_and_governed') {
      $closedAndGovernedFatcaForeignFinancialInstitutionType.removeClass('d-none');

      clearAndHideMultipleFieldInputs([
        $model2FatcaForeignFinancialInstitutionType,
        $waitingForGiinFatcaForeignFinancialInstitution_type,
        $otherFatcaForeignFinancialInstitutionType,
      ]);
    } else if (e.target.value === 'other') {
      $otherFatcaForeignFinancialInstitutionType.removeClass('d-none');

      clearAndHideMultipleFieldInputs([
        $model2FatcaForeignFinancialInstitutionType,
        $waitingForGiinFatcaForeignFinancialInstitution_type,
        $closedAndGovernedFatcaForeignFinancialInstitutionType,
      ]);
    } else if ([
        'participatory',
        'model_1',
        'governed',
        'documented',
        'undeclared_beneficiary',
        'conforming',
        'non_participatory',
      ].includes(e.target.value)) {
      clearAndHideMultipleFieldInputs([
        $model2FatcaForeignFinancialInstitutionType,
        $waitingForGiinFatcaForeignFinancialInstitution_type,
        $closedAndGovernedFatcaForeignFinancialInstitutionType,
        $otherFatcaForeignFinancialInstitutionType,
      ]);
    }
  });

  // fatca_non_foreign_financial_institution_type logic

  $fatcaForeignNonFinancialInstitutionTypeButtons.on('change', (e) => {
    if (e.target.value == 'other') {
      $otherFatcaForeignNonFinancialInstitutionType.removeClass('d-none')
    } else if (['exempt', 'passive'].includes(e.target.value)) {
      clearAndHideMultipleFieldInputs([$otherFatcaForeignNonFinancialInstitutionType]);
    }
  });

  // CRS logic

  $('#users_profile_legal_crs_financial_institution_true', $form).on('click', (_e) => {
    $declaringCrsFinancialInstitutionButtons.removeClass('d-none');
    clearAndHideMultipleFieldInputs([$activeCrsNonFinancialInstitutionButtons]);
  });

  $('#users_profile_legal_crs_financial_institution_false', $form).on('click', (_e) => {
    $activeCrsNonFinancialInstitutionButtons.removeClass('d-none');
    clearAndHideMultipleFieldInputs([$declaringCrsFinancialInstitutionButtons]);
  });
});
